import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary/20 py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/63919f1218177b7717c8f3f0981d9dd4.png"
                alt="赤ちゃんダイアリー"
                className="w-10 h-10 rounded-lg"
              />
              <span className="text-xl font-bold font-maru text-text-primary">
                赤ちゃんダイアリー
              </span>
            </div>
            <p className="text-sm text-text-secondary leading-relaxed">
              赤ちゃんの成長を記録し、大切な思い出を残すためのアプリです。
            </p>
          </div>

          {/* Links Section */}
          <div>
            <h3 className="text-base font-bold font-maru text-text-primary mb-4">
              リンク
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-text-secondary hover:text-text-primary transition-colors cursor-pointer"
                >
                  ホーム
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-text-secondary hover:text-text-primary transition-colors cursor-pointer"
                >
                  利用規約
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-text-secondary hover:text-text-primary transition-colors cursor-pointer"
                >
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-text-secondary hover:text-text-primary transition-colors cursor-pointer"
                >
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-base font-bold font-maru text-text-primary mb-4">
              お問い合わせ
            </h3>
            <p className="text-sm text-text-secondary mb-3">
              ご質問やご要望がございましたら、お気軽にお問い合わせください。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-sm font-medium text-cta hover:text-cta/80 transition-colors cursor-pointer whitespace-nowrap"
            >
              お問い合わせフォーム
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-text-secondary/20 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-text-secondary">
            © 2025 Kobayashi Ryotaro. All rights reserved. |{' '}
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-text-primary transition-colors cursor-pointer whitespace-nowrap"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;